import { BrowserRouter as Router } from 'react-router-dom';
import { AppProviders } from './providers';
import DrilldownModal from './components/drilldown/DrilldownModal';
import { WelcomeModal, QuickReferenceModal, GuidedTour } from './components/tour';
import { PageHelpPanel, GlossaryModal } from './components/help';
import { ErrorBoundary } from './components/common';
import TermsAcceptanceModal from './components/legal/TermsAcceptanceModal';
import EnvironmentIndicator from './components/EnvironmentIndicator';
import { Toaster } from 'sonner';
import { AppRoutes } from './routes';

function App() {
  return (
    <ErrorBoundary
      onError={(error) => {
        // Log critical app-level errors
        console.error('[App] Critical error:', error);
        // TODO: Send to error tracking service (e.g., Sentry)
      }}
    >
      <Router
        future={{
          // Opt in to React Router v7 behaviour today so v7 deprecation
          // warnings stay out of the console and the upgrade path is a
          // no-op when we bump the major version.
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <AppProviders>
          <AppRoutes />
          <TermsAcceptanceModal />
          <DrilldownModal />
          <WelcomeModal />
          <QuickReferenceModal />
          <GuidedTour />
          <PageHelpPanel />
          <GlossaryModal />
          <Toaster position="top-right" richColors />
          <EnvironmentIndicator />
        </AppProviders>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
